export default __webpack_public_path__ + "static/media/GOTG.590b1e0b.png";